// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce1539bd","453":"6eb9a9ce","455":"e65482e2"}[chunkId] + ".chunk.js";
};